/**
 * <SchoolAssessmentDetailModal> — le détail d'un contrôle (template).
 *
 * L'accordéon a quitté l'accueil ; ce qu'il montrait et permettait est ICI, en entier : l'en-tête
 * du contrôle (matière, titre, date, chip J-n, préparation d'ensemble), « À réviser » écrit en
 * toutes lettres, la progression chapitre par chapitre, puis « Modifier » et « Supprimer ».
 *
 * Coquille seule, comme `<NpsModal>` / `<ReferralModal>` : le contenu vient des deux molécules du
 * contrôle, `<SchoolAssessmentCard chevron={false}>` et `<SchoolAssessmentDetail>`. Rien n'est
 * redessiné ici, et la feuille se mesure sur son contenu — un contrôle à un chapitre n'a pas à
 * occuper 85 % de l'écran.
 */
import React from "react"

import { Modal } from "../../molecules/Modal"
import { SchoolAssessmentCard } from "../../molecules/SchoolAssessmentCard"
import { SchoolAssessmentDetail } from "../../molecules/SchoolAssessmentDetail"
import { type UISchoolAssessment } from "../../../ports/primary/ui/types"

export type SchoolAssessmentDetailModalProps = {
    visible: boolean
    onClose: () => void
    /** `null` ferme la feuille : la page n'a pas à garder un contrôle sélectionné pour rien. */
    assessment: UISchoolAssessment | null
    onEdit?: () => void
    onDelete?: () => void
    /** Le titre de la feuille — « Le contrôle » par défaut ; l'espace élève garde son « Détails du contrôle ». */
    title?: string
    /** Les noms de chapitre passent à la ligne au lieu d'être coupés — `false` par défaut. */
    wrapChapterNames?: boolean
    testID?: string
}

export function SchoolAssessmentDetailModal(props: SchoolAssessmentDetailModalProps) {
    const {
        visible,
        onClose,
        assessment,
        onEdit,
        onDelete,
        title = "Le contrôle",
        wrapChapterNames = false,
        testID,
    } = props
    if (assessment == null) return null

    return (
        <Modal
            visible={visible}
            onClose={onClose}
            title={title}
            fullScreenOnSmall
            sizeToContent
            dismissable
            testID={testID}
        >
            {/* La feuille pose déjà son retrait : les deux molécules laissent tomber le leur. */}
            <SchoolAssessmentCard assessment={assessment} chevron={false} p="0" />
            <SchoolAssessmentDetail
                assessment={assessment}
                showKeyRequirements
                wrapChapterNames={wrapChapterNames}
                p="0"
                onEdit={onEdit}
                onDelete={onDelete}
            />
        </Modal>
    )
}
